import { API_CONFIG } from '../config/api.config';

/**
 * Upload endpoints return paths relative to the API host ("/uploads/x.png").
 * Resolve them to absolute URLs so <img>/<a> work from the app origin and in
 * detached print windows.
 */
export const resolveFileUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  return `${API_CONFIG.BASE_URL}${url}`;
};
